import type { FC, SVGProps } from "react";

const IconChild: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 20 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		stroke="currentColor"
		{...props}
	>
		<path
			d="M8.33325 12.333C8.74992 12.583 9.33325 12.7497 9.99992 12.7497C10.6666 12.7497 11.2499 12.583 11.6666 12.333"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.5 9H12.5083"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.1501 4.6775C16.7343 5.527 17.1372 6.48783 17.3334 7.5C17.6152 7.63647 17.8528 7.84956 18.0191 8.11485C18.1854 8.38014 18.2736 8.68691 18.2736 9C18.2736 9.31309 18.1854 9.61986 18.0191 9.88515C17.8528 10.1504 17.6152 10.3635 17.3334 10.5C16.9737 12.1779 16.0494 13.6817 14.7148 14.7604C13.3803 15.8392 11.7161 16.4277 10.0001 16.4277C8.28405 16.4277 6.61991 15.8392 5.28534 14.7604C3.95078 13.6817 3.0265 12.1779 2.66675 10.5C2.38496 10.3635 2.14732 10.1504 1.98104 9.88515C1.81475 9.61986 1.72656 9.31309 1.72656 9C1.72656 8.68691 1.81475 8.38014 1.98104 8.11485C2.14732 7.84956 2.38496 7.63647 2.66675 7.5C3.01197 5.80875 3.92999 4.28835 5.26593 3.19531C6.60188 2.10226 8.27396 1.50348 10.0001 1.5C11.6667 1.5 12.9167 2.41667 12.9167 3.58333C12.9167 4.75 12.1667 5.66667 11.2501 5.66667C10.5834 5.66667 10.0001 5.33333 10.0001 4.83333"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.5 9H7.50833"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export default IconChild;
